<div class="evento-servico-page">
    <div class="card evento-servico-config-card">
        <div class="evento-servico-config-header">
            <h5 class="evento-servico-config-title">Configurações de eventos</h5>
            <p class="evento-servico-config-subtitle">
                Ajuste o comportamento da classificação de eventos do sistema.
            </p>
        </div>

        <p-message
            severity="info"
            styleClass="evento-servico-info-message"
            text="Quando a opção abaixo estiver marcada, a classificação do evento de nível oscilante ficará desativada em todo o sistema. Com a opção desmarcada, o evento continua sendo classificado normalmente.">
        </p-message>

        <div class="evento-servico-config-body" *ngIf="!loadingConfiguracaoGeral; else loadingConfiguracao">
            <div class="evento-servico-checkbox-row">
                <p-checkbox
                    inputId="evento_niveloscilante"
                    [(ngModel)]="eventoNivelOscilanteDesativado"
                    [binary]="true"
                    [disabled]="!direitoEditar || salvandoConfiguracaoGeral"
                    (onChange)="onEventoNivelOscilanteChange()">
                </p-checkbox>
                <label for="evento_niveloscilante" class="evento-servico-checkbox-label">
                    Desativar classificação de nível oscilante
                </label>
                <p-progressSpinner
                    *ngIf="salvandoConfiguracaoGeral"
                    [style]="{width: '24px', height: '24px'}"
                    strokeWidth="6"
                    animationDuration=".5s">
                </p-progressSpinner>
            </div>
        </div>

        <ng-template #loadingConfiguracao>
            <div class="evento-servico-config-loading">
                <p-progressSpinner
                    [style]="{width: '32px', height: '32px'}"
                    strokeWidth="6"
                    animationDuration=".5s">
                </p-progressSpinner>
                <span>Carregando configuração...</span>
            </div>
        </ng-template>
    </div>

    <div class="card evento-servico-container">
        <div class="evento-servico-table-wrapper" #tableWrapper>
            <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
                [paginator]="true" [rowHover]="true" dataKey="id"
                currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
                [globalFilterFields]="['id','Name', 'ScheduleExpression']"
                [scrollable]="true" [scrollHeight]="scrollHeight">

                <ng-template pTemplate="caption">
                    <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                        <h5 class="p-m-0">Serviços agendados</h5>
                        <span class="p-input-icon-left mt-2 md:mt-0">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="Pesquisar..." />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th>Descrição</th>
                        <th>Intervalo de tempo (minutos)</th>
                        <th>Editar</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-dt>
                    <tr>
                        <td><span class="p-column-title negrito">Descrição: </span>{{dt.Description}}</td>
                        <td><span class="p-column-title negrito">Configuração de tempo: </span>{{dt.time}}</td>
                        <td style="text-align: center;">
                            <span class="p-column-title negrito">Editar: </span>
                            <button pButton pRipple [disabled]="!direitoEditar"
                                icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                                (click)="edit(dt)"></button>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>

<p-dialog header="Evento" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '75vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">
            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="rule_description">
                    <label for="descricao">Descrição</label>
                </p-floatlabel>
            </div>

            <div *ngIf="cron" class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input min="00" max="23" type="number" id="schedule_expression_cron" pInputText
                        formControlName="schedule_expression_cron">
                    <label for="schedule_expression_cron">Intervalo de tempo (Horas)</label>
                </p-floatlabel>
            </div>

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="number" min="00" max="60" id="schedule_expression" pInputText
                        formControlName="schedule_expression">
                    <label for="schedule_expression">Intervalo de tempo (minutos)</label>
                </p-floatlabel>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>
